import { useTranslation } from 'react-i18next';
import { FontWeight, Heading, LiliTextInput } from '@lili/lili-frontend-common';
import { OnboardingFormFields } from '@Types/index.ts';
import { ControllerWrapper } from '@Hooks/index';
import { normalizeInputSpacesOnBlur, normalizeInputSpacesOnChange } from '@Services/utils/utils.ts';
import { PhoneInput } from '@Components/inputs/Phone';

export const OwnerDetailsForm = () => {
  const { t } = useTranslation();

  return (
    <div className=' w-full'>
      <Heading.H9 fontWeight={FontWeight.SEMIBOLD} className='mb-[16px] text-text-main-secondary'>
        {t('pages.addOwner.personalDetailsSection.title')}
      </Heading.H9>

      <ControllerWrapper name={OnboardingFormFields.FIRST_NAME}>
        {({ value, onChange, onBlur, error }) => (
          <LiliTextInput
            onChange={(val) => onChange(normalizeInputSpacesOnChange(val))}
            id={OnboardingFormFields.FIRST_NAME}
            title={t('pages.home.firstName')}
            errorMessage={error?.message}
            onBlur={() => {
              onChange(normalizeInputSpacesOnBlur(value));
              onBlur();
            }}
            value={value}
          />
        )}
      </ControllerWrapper>

      <ControllerWrapper name={OnboardingFormFields.LAST_NAME}>
        {({ value, onChange, onBlur, error }) => (
          <LiliTextInput
            onChange={(val) => onChange(normalizeInputSpacesOnChange(val))}
            id={OnboardingFormFields.LAST_NAME}
            title={t('pages.home.lastName')}
            errorMessage={error?.message}
            onBlur={() => {
              onChange(normalizeInputSpacesOnBlur(value));
              onBlur();
            }}
            value={value}
          />
        )}
      </ControllerWrapper>

      <PhoneInput />

      <ControllerWrapper name={OnboardingFormFields.EMAIL}>
        {({ value, onBlur, onChange, error }) => (
          <LiliTextInput
            id={OnboardingFormFields.EMAIL}
            title={t('pages.addOwner.personalDetailsSection.email')}
            onChange={onChange}
            onBlur={onBlur}
            value={value}
            errorMessage={error?.message}
          />
        )}
      </ControllerWrapper>
    </div>
  );
};
